<template>
  <el-form ref="form" :model="form" :inline="true">
    <div class="form_line1">
      <!-- <el-form-item prop="name" >
          <el-input
            v-model="form.name"
            autocomplete="off"
            class="msg-input"
            placeholder="请输入权限名"
          />
        </el-form-item> -->
      <el-form-item class="btn">
        <!-- <el-button
          @click="$emit('fetchData', form)"
          icon="el-icon-search"
          size="small"
          >查询</el-button
        >
        <el-button size="small" @click="resetForm">清空</el-button> -->
        <el-button
          size="small"
          icon="el-icon-plus"
          @click="$emit('openTitleForm')"
          type="primary"
          v-if="roleList[path].includes('_Add')"
          >新增</el-button
        >
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MenuSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  data() {
    return {
      // 表单内容
      form: {
        name: '',
      },
      loading: false,
      path: '',
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 清空表单
    resetForm() {
      this.form = {};
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
  flex-direction: column;
}
.form_line1 {
  // float:right
}
</style>
